/** What the answer of `billing.verifyCheckoutSession` says about the payment. */
export type CheckoutSessionState = 'paid' | 'processing' | 'notPaid';

/**
 * Reads the Stripe Checkout state of a verify answer (QA finding brk-8). `paid`: Stripe has the
 * money (or needs none). `processing`: the checkout is complete and a slow payment method still
 * runs. `notPaid`: the checkout is open or expired. Pure.
 */
export function checkoutSessionStateOf(answer: {
  status: string | null;
  paymentStatus: string | null;
}): CheckoutSessionState {
  if (answer.paymentStatus === 'paid' || answer.paymentStatus === 'no_payment_required') {
    return 'paid';
  }
  if (answer.status === 'complete') {
    return 'processing';
  }
  return 'notPaid';
}

/** The page state of the return from a plan checkout. */
export type PaymentPageStatus = 'checking' | 'success' | 'pending' | 'failed' | 'noSession';

/**
 * The page state when the polling stops with no paid answer. A complete checkout with a slow
 * payment method is "processing"; every other case (an open or expired checkout, a wrong or fake
 * session id, a read that always failed) is "failed": the page never says that a plan is active
 * without a paid checkout. Pure.
 */
export function finalPaymentStatusOf(lastState: CheckoutSessionState | null): PaymentPageStatus {
  return lastState === 'processing' ? 'pending' : 'failed';
}
